import { motion } from "framer-motion";
import { Star } from "lucide-react";
import { REVIEWS } from "../data/menu";
import { useLang } from "../i18n";

const Stars = () => (
  <div className="flex gap-1">
    {[...Array(5)].map((_, i) => (
      <Star key={i} size={13} className="fill-gold text-gold" />
    ))}
  </div>
);

export const Reviews = () => {
  const { t, isAr } = useLang();
  return (
    <section id="reviews" className="py-24 md:py-32 bg-parchment border-y border-line" data-testid="reviews-section">
      <div className="px-6 md:px-12 max-w-[1400px] mx-auto">
        <div className="grid md:grid-cols-12 gap-12 mb-16">
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, margin: "-80px" }}
            transition={{ duration: 0.8 }}
            className="md:col-span-4"
          >
            <p className="text-xs uppercase tracking-[0.35em] text-gold font-semibold mb-4">{t.reviews.kicker}</p>
            <div className="flex items-end gap-4">
              <span className="font-display font-light text-8xl md:text-9xl text-pine leading-none" data-testid="reviews-score" dir="ltr">
                4.9
              </span>
              <div className="pb-3">
                <Stars />
                <p className="text-smoke text-sm mt-2">{t.reviews.count}</p>
              </div>
            </div>
          </motion.div>
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, margin: "-80px" }}
            transition={{ duration: 0.8, delay: 0.1 }}
            className="md:col-span-8 flex items-end"
          >
            <h2 className="font-display font-light text-4xl md:text-5xl text-pine tracking-tight">
              {t.reviews.titleA} <span className="italic text-gold-shimmer">{t.reviews.titleB}</span>
              {t.reviews.titleC}
            </h2>
          </motion.div>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-5">
          {REVIEWS.map((r, i) => (
            <motion.blockquote
              key={r.name}
              initial={{ opacity: 0, y: 24 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-60px" }}
              transition={{ duration: 0.7, delay: i * 0.08 }}
              className="bg-paper border border-line p-8 flex flex-col justify-between hover:border-gold/60 transition-colors duration-500"
              data-testid={`review-card-${i}`}
            >
              <p className="font-display italic text-lg text-ink/85 leading-relaxed">“{isAr ? r.textAr : r.text}”</p>
              <footer className="mt-8 flex items-center justify-between">
                <span className="text-xs uppercase tracking-[0.2em] text-smoke">{isAr ? r.nameAr : r.name}</span>
                <Stars />
              </footer>
            </motion.blockquote>
          ))}
        </div>
      </div>
    </section>
  );
};
